import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import NotificationHeader from "./NotificationHeader";
import NotificationFooter from "./NotificationFooter";
const Notification = t0 => {
  const $ = _c(8);
  const {
    setNotification
  } = t0;
  const [activeTab, setActiveTab] = useState("all");
  let t1;
  if ($[0] !== activeTab || $[1] !== setNotification) {
    t1 = <NotificationHeader setNotification={setNotification} activeTab={activeTab} setActiveTab={setActiveTab} />;
    $[0] = activeTab;
    $[1] = setNotification;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== activeTab) {
    t2 = <NotificationFooter activeTab={activeTab} />;
    $[3] = activeTab;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <><main className="flex w-full flex-col pt-4 sm:pt-6 rounded-2xl sm:rounded-3xl bg-neutral-100">{t1}{t2}</main></>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default Notification;